module.exports = __webpack_public_path__ + "static/img/prize4.23765de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_activitycenter/prize4.png
// module id = N2JP
// module chunks = 1